import React from 'react';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {Atom} from '@packages/systems/wfdl';
import {
  USYS_DATA_ATTRS,
  USYS_FORM_TYPES,
} from '@packages/systems/users/constants';

import {TListOfElement} from '@packages/systems/wfdl-ast';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserLogInForm = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
    sharedContext: {hrefMap},
    context,
  }) => {
    const redirectPageId = context.get('redirectPageId');
    const redirectSlug = (redirectPageId && hrefMap[redirectPageId]) || '/';

    const props = {
      ...generateAttributes(attributes, classes),
      [USYS_DATA_ATTRS.formType]: USYS_FORM_TYPES.login,
      [USYS_DATA_ATTRS.redirectUrl]: redirectSlug,
    } as const;

    return (
      <form {...props} method="post">
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </form>
    );
  }
);

const config = createIntegratedAtom({
  constraints: {
    ancestors: [{is: 'UserLogInFormWrapper', rule: 'ExactlyOne'}],
    page: [
      {
        type: 'UtilityPage',
        is: 'usys-log-in',
      },
    ],
    descendants: [
      {
        is: 'UserFormEmailInput',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserFormPasswordInput',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserFormButton',
        rule: 'ExactlyOne',
      },
    ],
    pinToParent: true,
  },
  displayName: 'Log In Form',
  render: UserLogInForm,
  showEmpty: true,
  fields: {
    children: TListOfElement,
  },
});

export default config;
